import * as React from "react"
export const Svg_070 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={59}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M39.72 25.467c0 3.79-3.03 6.872-6.755 6.872H48.37V18.594H32.965c3.725 0 6.756 3.083 6.756 6.873Z"
    />
    <path
      fill="url(#b)"
      d="M32.965 28.882c1.854 0 3.357-1.529 3.357-3.415 0-1.886-1.503-3.416-3.357-3.416-1.855 0-3.358 1.53-3.358 3.416s1.503 3.415 3.358 3.415Z"
    />
    <path
      fill="url(#c)"
      d="M4.531 15.713H0v34.488h51.203v-4.61H4.531V15.713Z"
    />
    <path
      fill="url(#d)"
      d="M26.209 25.467c0-3.79 3.03-6.873 6.756-6.873H17.559V32.34h15.406c-3.725 0-6.756-3.083-6.756-6.872Z"
    />
    <path
      fill="url(#e)"
      d="M58 42.134V8.8H7.93v33.335H58Zm-6.23-26.997v20.66H14.16v-20.66h37.61Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={36.528}
        x2={42.7}
        y1={20.656}
        y2={31.854}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={31.16}
        x2={34.429}
        y1={23.076}
        y2={28.277}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={11.841}
        x2={24.836}
        y1={20.887}
        y2={52.112}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={21.121}
        x2={27.294}
        y1={20.656}
        y2={31.854}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={19.508}
        x2={31.967}
        y1={13.8}
        y2={44.084}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)